<template>
  <div style="height: 500px">
    <v-progress-linear
      exact
      style="width: 350px;"
      class="rotate-90"
      :color="colour"
      height="200"
      :value="completed"
    >
      <div>
        <v-icon
          medium
          dark
          class="metric-icon"
        >
          {{ icon }}
        </v-icon>
      </div>
    </v-progress-linear>
    <div class="metric-description">
      {{ description }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    colour: {
      type: String,
      default: 'secondary',
    },
    description: {
      type: String,
      default: '',
    },
    completed: {
      type: Number,
      default: 0,
    },
    icon: {
      type: String,
      default: 'mdi-flip-to-front',
    },
    height: {
      type: Number,
      default: 300,
    },
  },
};
</script>
<style scoped>
.rotate-90 {
  transform: rotate(-90deg);
  top: 200px;
}
.metric-description {
  position: relative;
  bottom: -205px;
  text-align: center;
  left: 75px;
  width: 93px;
  color: white;
  margin-left: auto;
  margin-right: 98px;
}
.metric-icon {
  font-size: 105px !important;
  transform: rotate(90deg);
  padding-left: 0px;
  padding-bottom: 100px;
}
</style>
